import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, CadastrarParametroSistemaRedis } from './types';

export const INITIAL_STATE: CadastrarParametroSistemaRedis = {
	status: 0,
};

export default function cadastrarParametroSistemaRedisReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastrarParametroSistemaRedis {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_PARAMETRO_SISTEMA_REDIS: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_SISTEMA_REDIS_SUCCESS: {
				draft.status = action.payload.status;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_SISTEMA_REDIS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_SISTEMA_REDIS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
	});
}
